/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_form_down': {
    width: 13,
    height: 9,
    viewBox: '0 0 13 9',
    data: '<path pid="0" d="M1.191 1.544L6.698 7.05l5.507-5.506" _stroke="#909090" stroke-width="1.573"/>'
  }
})
